import React from 'react';
import { Box } from '@chakra-ui/react';
import Metronome from './components/Metronome';

function App() {
  return (
    <Box>
      <Metronome />
    </Box>
  );
}

export default App;